import Slider5 from './Slider5'
export default Slider5
